import { combineReducers } from 'redux';
import { reducer as modalReducer } from 'redux-modal';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { reducer as formReducer } from 'redux-form/immutable';
import AuthStore from 'js/services/auth/auth-store';
import shoppingCartReducer from './reducers/payment/shoppingCart/reducer';
import device from './reducers/nav/device'; // auth

import { authForms } from './reducers/auth/auth';
import user from './reducers/auth/user/reducer'; // nav

import feedbackMenu from './reducers/nav/feedbackMenu';
import headerReducer from './reducers/nav/header/reducer';
import downloadMenu from './reducers/nav/downloadMenu';
import localization from './reducers/nav/localization'; // plot data

import plotRadios from './reducers/legacy/plotRadios';
import countryDataReducer from './reducers/country/reducer';
import countryMetadata from './reducers/legacy/countryMetadata';
import plotSampleRates from './reducers/legacy/plotSampleRates';
import plotCheckboxes from './reducers/country/plot/controls/dataShown/checkbox/legacy/plotCheckboxes';
import graphGeneratorData from './reducers/legacy/graphGeneratorData';
import availableCountriesMetadata from './reducers/legacy/availableCountriesMetadata'; // shopping cart

import checkout from './reducers/payment';
var authStore = new AuthStore();
var reducer = combineReducers({
  auth: authStore,
  nav: headerReducer,
  user: user,
  userAuth: user,
  // fix this
  form: formReducer,
  modal: modalReducer,
  toastr: toastrReducer,
  country: countryDataReducer,
  // split this content in folders
  shoppingCart: shoppingCartReducer,
  device: device,
  checkout: checkout,
  authForms: authForms,
  plotRadios: plotRadios,
  localization: localization,
  feedbackMenu: feedbackMenu,
  downloadMenu: downloadMenu,
  plotCheckboxes: plotCheckboxes,
  countryMetadata: countryMetadata,
  plotSampleRates: plotSampleRates,
  graphGeneratorData: graphGeneratorData,
  availableCountriesMetadata: availableCountriesMetadata
});
export default reducer;